import SidebarLayout from "../BankerUI/SidebarLayout";
import React, { useState, useEffect } from 'react';
import { Typography, Button, Row, Col, Card, Spin, Space, Tooltip, message, Collapse } from 'antd';
import { useHistory } from "react-router-dom";
import DonutChart from '../../components/DonutChart';
import { routes } from '../../routes/Routes';
import { RightOutlined, QuestionCircleOutlined, DollarOutlined, DownOutlined, UpOutlined } from "@ant-design/icons";
import _BankerService from '../../modules/BankerService';
import { COMMON_ERROR_MSG } from '../../constants/constants';
import _NewapplicationService from "../../modules/NewapplicationService";
import _commonService from "../../modules/commonService";
import "./FirmAdminDashboard.scss";

const { Title, Text } = Typography;
const { Panel } = Collapse;

const FirmAdminDashboard = () => {
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [sponserData, setSponserData] = useState([]);
    const loginEmail = localStorage.getItem("loginEmail")
    const bankadminIdRaw = localStorage.getItem("BankAdminId");
    const BankAdminId = bankadminIdRaw ? parseInt(bankadminIdRaw) : null;
    const [BankAdminID, setBankAdminID] = useState(BankAdminId);
    const [expandedFirmKeys, setExpandedFirmKeys] = useState([]);
    useEffect(() => {
        if (BankAdminID && loginEmail) {
            getSponserDataBySponserId(loginEmail, BankAdminID);
        }
    }, [BankAdminID, loginEmail]);
    useEffect(() => {
        const handleBankAdminIdChange = (e) => {
            const newId = e.detail.newId;
            setBankAdminID(newId);
        };

        window.addEventListener("BankAdminIdChanged", handleBankAdminIdChange);

        return () => {
            window.removeEventListener("BankAdminIdChanged", handleBankAdminIdChange);
        };
    }, []);

    const onEditSponserClick = (dataObj) => {
        if (dataObj.FirmId) {
            history.push({
                pathname: routes.firmadminfacilitydetails.path,
                state: { firmId: dataObj.FirmId, companyName: dataObj.CompanyName },
            });
            return;
        }
        history.push({
            pathname: routes.firmadminsponsersdetails.path,
            state: { sponserId: dataObj.SponserId || dataObj.Id },
        });
    }

    const toggleFirmBreakdown = (key) => {
        setExpandedFirmKeys((prevKeys) =>
            prevKeys.includes(key) ? prevKeys.filter((k) => k !== key) : [...prevKeys, key]
        );
    };

    // useEffect(() => {
    //     getSponserDataBySponserId(loginEmail, BankAdminID);
    // }, []);

    const getSponserDataBySponserId = async (loginEmail, BankAdminId) => {
        try {
            setLoading(true);
            const res = await _NewapplicationService.getFirmCreditFacilityListByEmailAndBankAdminId(loginEmail, BankAdminId);
            if (res.data.IsSuccess) {
                setLoading(false);
                let resObj = res.data.Obj;
                setSponserData(resObj || []);
            } else {
                setLoading(false);
                setSponserData([])
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (error) {
            setLoading(false);
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const totalInProgress = sponserData.reduce(
        (sum, item) => sum + Number(item?.Inprogressed || 0),
        0
    );

    const totalApproved = sponserData.reduce(
        (sum, item) => sum + Number(item?.Approved || 0),
        0
    );

    console.log(sponserData, "sponserdata")
    return (
        // <Spin spinning={loading}>
        //     <SidebarLayout>
        //         <div>
        //             <Title level={3}>Firm Admin Dashboard</Title>
        //         </div>

        //         <Row gutter={[16, 16]}>
        //             {sponserData?.map((sponserData, index) => (
        //                 <Col
        //                     key={sponserData.Id || index}
        //                     className="gutter-row"
        //                     xs={{ span: 24 }}
        //                     sm={{ span: 12 }}
        //                     md={{ span: 12 }}
        //                     lg={{ span: 12 }}
        //                     xl={{ span: 8 }}
        //                     xxl={{ span: 8 }}
        //                 >
        //                     <Card

        //                         title={
        //                             <Row
        //                                 justify="space-between"
        //                                 align="middle"

        //                             >
        //                                 <Tooltip title={sponserData?.CompanyName}>
        //                                     <span

        //                                     >
        //                                         {sponserData?.CompanyName}
        //                                     </span>
        //                                 </Tooltip>

        //                                 <Button
        //                                     type="link"

        //                                     className="viewBtn"
        //                                     onClick={() => onEditSponserClick(sponserData)}
        //                                 >
        //                                     View Details
        //                                     <RightOutlined style={{ marginLeft: 5 }} />
        //                                 </Button>
        //                             </Row>
        //                         }
        //                     >
        //                         <Row justify="space-around" align="middle">
        //                             {/* Left - Donut chart */}
        //                             <Col>
        //                                 <Row
        //                                     className="iconFont"
        //                                     align="middle"
        //                                     justify="center"

        //                                 >
        //                                     <div >
        //                                         <Text strong className="ant-card-head-title" >
        //                                             Limit Usage
        //                                         </Text>
        //                                         <Tooltip title="What is Limit Usage?">
        //                                             <span>
        //                                                 <QuestionCircleOutlined className="ml10"/>
        //                                             </span>
        //                                         </Tooltip>
        //                                     </div>
        //                                 </Row>

        //                                 <div className="aligntext">
        //                                     <DonutChart
        //                                         data={[
        //                                             { type: "Remaining", value: Number(sponserData?.Remaining) },
        //                                             { type: "Utilized", value: Number(sponserData?.Utilized) },
        //                                         ]}
        //                                         title="Budget"
        //                                     />
        //                                 </div>
        //                             </Col>

        //                             {/* Right - Active Loans */}
        //                             <Col className="mt20 centerAlign">
        //                                 <Space direction="vertical" size={8}>
        //                                     <Title
        //                                         level={5}

        //                                     >
        //                                         <DollarOutlined /> Active Loan Programs
        //                                     </Title>
        //                                     <Text >
        //                                         In Progress: <strong>{sponserData?.Inprogressed || "0"}</strong>
        //                                     </Text>
        //                                     <Text>
        //                                         Approved: <strong>{sponserData?.Approved || "0"}</strong>
        //                                     </Text>
        //                                 </Space>
        //                             </Col>
        //                         </Row>
        //                     </Card>
        //                 </Col>
        //             ))}
        //         </Row>

        //     </SidebarLayout>
        // </Spin>

        <Spin spinning={loading}>
            <SidebarLayout>

                {/* PARENT CLASS */}
                <div className="firm-admin-dashboard">

                    <h4 level={3} className="title">
                        Firm Administrator Dashboard
                        <div><text className="dashboard-subtitle">Utilization Summary.</text></div>

                    </h4>


                    <Row gutter={[16, 16]}>
                        {sponserData?.map((item, index) => (
                            <Col
                                key={item.FirmId || item.SponserId || index}
                                xs={24}
                                sm={12}
                                md={12}
                                lg={12}
                                xl={8}
                            >
                                <Card
                                    className="loan-card-app"
                                    title={
                                        <Row justify="space-between" align="middle">
                                            <div>
                                                <Tooltip title={item?.CompanyName}>
                                                    <span className="company-name">
                                                        {item?.CompanyName}
                                                    </span>
                                                </Tooltip>
                                                <div className="statusapp-name">
                                                    Firm Name
                                                </div>
                                            </div>


                                            <Button
                                                type="link"
                                                className="app-view-Btn"
                                                onClick={() => onEditSponserClick(item)}
                                            >
                                                View Details <RightOutlined />
                                            </Button>
                                        </Row>

                                    }
                                >

                                    {/* BODY */}

                                    <Row justify="space-between" align="middle">

                                        <Col span={24} className="aligntext donut-chart-col">
                                            <Row justify="center" align="middle">
                                                <Col flex="none">
                                                    <div className="w250">
                                                        <DonutChart
                                                            data={[
                                                                { type: "Remaining", value: Number(item?.Remaining) },
                                                                { type: "Utilized", value: Number(item?.Utilized) },
                                                            ]}
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>

                                    {/* FOOTER */}
                                    {/* <Row className="card-footer">

                                        <div className="footer-block">
                                            <span>Remaining</span>
                                            <h4>${item?.Remaining}</h4>

                                            <small>
                                                {Number(item?.Limit) > 0
                                                    ? Math.round((Number(item?.Remaining) / Number(item?.Limit)) * 100)
                                                    : 0}
                                                %
                                            </small>
                                        </div>

                                        <div className="footer-block">
                                            <span>Utilized</span>
                                            <h4>${item?.Utilized}</h4>

                                            <small>
                                                {item?.Utilized && item?.Limit
                                                    ? Math.round((item.Utilized / item.Limit) * 100)
                                                    : 0}
                                                %
                                            </small>
                                        </div>

                                    </Row> */}

                                    <Row className="card-footer">

                                        <div>
                                            <span>Total Limit</span>
                                            <h4>${_commonService.formatNumberWithCommas(item?.TotalProgrameSize) || "N/A"}</h4>
                                        </div>

                                        <div>
                                            <span>Utilized</span>
                                            <h4>${_commonService.formatNumberWithCommas(item?.Utilized) || "N/A"}</h4>
                                        </div>

                                        <div>
                                            <span>Remaining</span>
                                            <h4>${_commonService.formatNumberWithCommas(item?.Remaining) || "N/A"}</h4>
                                        </div>

                                        {/* <div>
                                            <span>Active Loans</span>
                                            <h4>{_commonService.formatNumberWithCommas(item?.Inprogressed) || "N/A"}</h4>
                                        </div> */}

                                    </Row>

                                    {item.Breakdown && item.Breakdown.length > 0 && (
                                        <Collapse
                                            className="collapseHeaderColor card-section firm-breakdown-collapse"
                                            activeKey={expandedFirmKeys.includes(item.FirmId || item.SponserId) ? ["1"] : []}
                                            expandIcon={({ isActive }) => (
                                                <span
                                                    onClick={() => toggleFirmBreakdown(item.FirmId || item.SponserId)}
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    {isActive ? <UpOutlined /> : <DownOutlined />}
                                                </span>
                                            )}
                                            expandIconPlacement="end"
                                        >
                                            <Panel
                                                key="1"
                                                showArrow={true}
                                                header={
                                                    <div
                                                        onClick={() => toggleFirmBreakdown(item.FirmId || item.SponserId)}
                                                        style={{ cursor: "pointer" }}
                                                    >
                                                        <Text strong>Credit Facility Type Breakdown</Text>
                                                    </div>
                                                }
                                            >
                                                {item.Breakdown.map((b, bi) => (
                                                    <div key={bi} style={{ marginBottom: bi === item.Breakdown.length - 1 ? 0 : 28 }}>
                                                        <Text strong>{b.LoanProgrameTypeName ? (b.CreditFacilityName ? `${b.LoanProgrameTypeName} (${b.CreditFacilityName})` : b.LoanProgrameTypeName) : "N/A"}</Text>
                                                        <Row className="card-footer" style={{ marginTop: 6, paddingTop: 6 }}>
                                                            <div>
                                                                <span>Total Limit</span>
                                                                <h4>${_commonService.formatNumberWithCommas(b.TotalProgrameSize) || "N/A"}</h4>
                                                            </div>
                                                            <div>
                                                                <span>Utilized</span>
                                                                <h4>${_commonService.formatNumberWithCommas(b.Utilized) || "N/A"}</h4>
                                                            </div>
                                                            <div>
                                                                <span>Remaining</span>
                                                                <h4>${_commonService.formatNumberWithCommas(b.Remaining) || "N/A"}</h4>
                                                            </div>
                                                            {/* <div>
                                                                <span>Active Loans</span>
                                                                <h4>{_commonService.formatNumberWithCommas(b.Inprogressed) || "N/A"}</h4>
                                                            </div> */}
                                                        </Row>
                                                    </div>
                                                ))}
                                            </Panel>
                                        </Collapse>
                                    )}

                                </Card>
                            </Col>
                        ))}
                    </Row>
                    {/* <Row>
                        <Col span={24} className="ActiveLoanPrograms">
                            <Row
                                gutter={[16, 16]}
                            >
                                <Col span={24} className="ant-typography">
                                    <Title
                                        level={5}
                                    >
                                        Active Credit Facility
                                    </Title>
                                </Col>
                                <Col span={12} >

                                    <div className='active-loans-title' >
                                        <Title level={5} className="loan-programs-subtitle " >
                                            In Progress:

                                        </Title>
                                        <span>
                                           

                                            <span>
                                                ${_commonService.formatNumberWithCommas(totalInProgress || 0)}
                                            </span>

                                        </span>

                                    </div>
                                </Col>

                                <Col span={12} >

                                    <div className="active-loans-title">
                                        <Title level={5} className="loan-programs-subtitle ">
                                            Approved:

                                        </Title>

                                        <span>
                                            {_commonService.formatNumberWithCommas(totalApproved)}
                                        </span>

                                    </div>
                                </Col>
                            </Row>
                        </Col>

                    </Row> */}



                </div>

            </SidebarLayout>
        </Spin>

    )
}
export default FirmAdminDashboard;